import { setDayjsLocale } from '@/assets/dayjsLocales';
import { mutationTypes, actionTypes, errorTypes } from '@/types';

export default async function setLanguage({ state, getters, commit, dispatch }, { language }) {
	if (!getters.possibleLanguages.includes(language)) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.languageNotSupported) });
		commit(mutationTypes.setLanguage, { language: state.defaultLanguage });
	} else {
		await dispatch(actionTypes.loadCalendar, { language });
		await dispatch(actionTypes.loadGlossary, { language });
		commit(mutationTypes.setLanguage, { language });
	}
	await setDayjsLocale(language, dispatch);
	dispatch(actionTypes.loadContent, {
		exhibitionID: state.currentExhibitionID,
		articleID: state.currentArticleID,
		tourID: state.tour.tourCurrentID,
	});
}
